// images
import mainCountryHouse from "../assets/mainPage/mainCountryHouse.webp";
import iskusstv1 from "../assets/otherPages/countryHouse/isskustv_1.webp";
import iskusstv2 from "../assets/otherPages/countryHouse/isskustv_2.webp";
import iskusstv3 from "../assets/otherPages/countryHouse/isskustv_3.webp";

import opisaniebanisaun1 from "../assets/otherPages/countryHouse/opisanie_ban_i_saun.webp";
import opisanieban1 from "../assets/otherPages/countryHouse/opisanie_ban_1.webp";
import opisanieban2 from "../assets/otherPages/countryHouse/opisanie_ban_2.webp";
import opisanieban3 from "../assets/otherPages/countryHouse/opisanie_ban_3.webp";

import vybiraemgazonokosilku from "../assets/otherPages/countryHouse/vybiraem_gazonokosilku.webp";
import vybiraemgaz1 from "../assets/otherPages/countryHouse/vybiraem_gaz_1.webp";
import vybiraemgaz2 from "../assets/otherPages/countryHouse/vybiraem_gaz_2.webp";

import vidyVenikov1 from '../assets/otherPages/countryHouse/vidy_bann_venikov.webp'
import vidyVenikov2 from '../assets/otherPages/countryHouse/vidy_venikov1.webp'
import vidyVenikov3 from '../assets/otherPages/countryHouse/vidy_venikov2.webp'
import vidyVenikov4 from '../assets/otherPages/countryHouse/vidy_venikov3.webp'
import vidyVenikov5 from '../assets/otherPages/countryHouse/vidy_venikov4.webp'


// country house articles
export const countryHouseArticles = [
  // ARTICLE 1 START
  {
    id: "Искусственный водоем своими руками",
    img: mainCountryHouse,
    pretitle: "Дача",
    title: "Искусственный водоем своими руками",
    tagString: "дача искусственный водоем пруд",
    tags: [
      {
        tag: "дача",
        tagLink: "#",
      },
      {
        tag: "искусственный",
        tagLink: "#",
      },
      {
        tag: "водоем",
        tagLink: "#",
      },
      {
        tag: "пруд",
        tagLink: "#",
      },
    ],
    linkToArticle: "/country/Искусственный водоем своими руками",
    text: [
      {
        attribute: "paragraph",
        content:
          "Искусственный пруд на вашем приусадебном участке создаст неповторимую атмосферу гармонии и безмятежности. Привлечет полезных насекомых и птиц. Прочитав эту статью, вы убедитесь, что сделать водоем своими руками, совсем не сложно.",
      },
      {
        attribute: "image",
        content: iskusstv1,
      },
      {
        attribute: "paragraph",
        content:
          "Не следует выкапывать глубокий котлован с крутыми берегами — это неизбежно приведет к осыпанию грунта и усложнит процесс обустройства береговой линии. Дно для искусственного водоема, обычно, делают ступенчатым. На верхних уступах будут располагаться водные растения.",
      },
      {
        attribute: "paragraph",
        content:
          "Прежде чем начать укладку гидроизоляционной пленки, необходимо очистить дно от корней деревьев, камней и других предметов, способных повредить гидроизоляцию. Для повышения срока службы гидроизоляционного материала, рекомендуется засыпать дно слоем песка(5-10 см) и проложить дренажные трубы.",
      },
      {
        attribute: "image",
        content: iskusstv2,
      },
      {
        attribute: "paragraph",
        content:
          "В первую очередь, дно будущего пруда покрывается геовойлоком, необходимым для распределения давления воды и служащим дополнительной защитой от механических повреждений. При покупке материала, учтите, что он укладывается внахлест, так у рулона шириной один метр — рабочая ширина составит от 80 до 90 см.",
      },
      {
        attribute: "paragraph",
        content:
          "Делая выбор гидроизоляционной пленки, следует отдать предпочтение более плотной. В продаже имеются особо прочные экземпляры, толщиной до 1,2 мм. Рассчитать общую площадь, которую необходимо покрыть пленкой, можно, прибавив к максимальным длине и ширине котлована, две глубины и плюс дополнительные 60 см, необходимые для обустройства берега. Для склеивания пленки приобретите специальный клей.",
      },
      {
        attribute: "image",
        content: iskusstv3,
      },
      {
        attribute: "paragraph",
        content:
          "После заливания водой, начинается процесс декорирования береговой линии. Существует много способов оформления: посадка растений, использование камней, деревянных настилов и т. д. ",
      },
    ],
  },
  // ARTICLE 1 END

  // ARTICLE 2 START
  {
    id: "Описание бань и саун",
    img: opisaniebanisaun1,
    pretitle: "Дача",
    title: "Описание бань и саун",
    tagString: "баня сауна терма хаммам",
    tags: [
      {
        tag: "баня",
        tagLink: "#",
      },
      {
        tag: "сауна",
        tagLink: "#",
      },
      {
        tag: "терма",
        tagLink: "#",
      },
      {
        tag: "хаммам",
        tagLink: "#",
      },
    ],
    linkToArticle: "/country/Описание бань и саун",
    text: [
      {
        attribute: "paragraph",
        content:
          "В данной статье вниманию читателя представлены краткие описания самых популярных типов национальных бань, таких как русские, финские, японские, турецкие и римские.",
      },
      {
        attribute: "paragraph",
        content:
          "Основными отличиями являются температурный режим и влажность воздуха в парильном помещении, способ обогрева и внутренне убранство.",
      },
      {
        attribute: "paragraph",
        content:
          "Прочитав эту статью у вас уже никогда не возникнет вопроса, чем отличается русская баня от финской сауны или римская терма от японской офуро.",
      },
      {
        attribute: "image",
        content: opisanieban1,
      },
      {
        attribute: "title",
        content: "Русские бани",
      },
      {
        attribute: "paragraph",
        content:
          "Русская баня является родной сестрой сауны — финской бани. Одинаковые в своих конструкциях бани и сауны, имеют ряд существенных различий. Во-первых влажность воздуха в парильном помещении. По традиции процесс парки начинается с расплескивания воды на печь-каменку, в результате чего образуется горячий пар, а температура воздуха достигает 100°C. Еще одно существенное отличие мытья в русской бане — это использование банных веников березовых, дубовых и т.д., предварительно запаренных специальным способом. Конструктивной особенностью является — купель, с холодной или   ледяной водой. Во всем остальном бани и сауны схожи.",
      },
      {
        attribute: "image",
        content: opisanieban2,
      },
      {
        attribute: "title",
        content: "Финские бани(сауны)",
      },
      {
        attribute: "paragraph",
        content:
          "Главное отличие сауны от русской бани — низкая влажность воздуха, этот показатель не должен превышать 20%, а температура при этом может подниматься до 130 - 160°C. Высокая температура гораздо легче переносится организмом человека, благодаря относительно низкой влажности. Конструктивно отличается от бани большим парильным отделением, и наличием бассейна с водой комнатной температуры. Материалом для внутренней отделки как саун, так и бань, служат сосна или береза. Обогрев осуществляется с помощью камней, уложенных на электрической, либо обычной печи на дровах.",
      },
      {
        attribute: "image",
        content: opisanieban3,
      },
      {
        attribute: "title",
        content: "Японские бани(сэнто или офуро)",
      },
      {
        attribute: "paragraph",
        content:
          "Японские бани представляет собой деревянные бочки или небольшие бассейны с нагретой водой температурой 40-50°C. Прежде чем посетить офуро, рекомендуется принять душ, и только после этого разместиться на специальной скамеечке, находящейся внутри деревянной ванны. Во время приема японской бани, важно следить за тем, чтобы линия воды находилась ниже уровня сердца сидящего. Еще одним важным условием является — поддержание чистоты воды в офуро — исключается использование моющих средств. Для повышения целебных и расслабляющих свойств, в воду могут быть добавлены различные ароматические соли и порошки.",
      },
      {
        attribute: "title",
        content: "Римские бани(термы)",
      },
      {
        attribute: "paragraph",
        content:
          "У римских терм очень богатая история. В Древней Греции и Римской империи они являлись популярными общественными местами для отдыха и укрепления здоровья. Сегодня римские бани, как и в былые времена, представляют собой обширные строения с большим количеством парильных отделений, а также разнообразных помещений для занятий спортом, для массажа, бассейны с водой разной температуры и не только. Интерьер, отделывается мрамором,  украшается настенными мозаиками, скульптурами и фонтанами с питьевой водой. Парильное помещение обогревается горячим воздухом и паром, которые циркулируют по специальным трубам, уложенным под полом и вмонтированным в стены. Температура воздуха достигает 50-65°C, а влажность  до 90-95%.",
      },
      {
        attribute: "title",
        content: "Турецкие бани(хаммамы)",
      },
      {
        attribute: "paragraph",
        content:
          "Турецкие хаммамы представляют собой модифицированные римские термы, они во многом схожи по своему строению. Основными отличиями турецких бань являются — постепенное повышение температуры в парильне от 50 до 100°C, для этого существует несколько последовательно устроенных парильных комнат, в которые переходят в порядке возрастания температуры; а также в способе подачи горячего воздуха и пара — через отверстия в стенах, расположенных на высоте около одного метра над уровнем пола.",
      },
    ],
  },
  // ARTICLE 2 END

  // ARTICLE 3 START
  {
    id: "Выбираем газонокосилку",
    img: vybiraemgazonokosilku,
    pretitle: "Дача",
    title: "Выбираем газонокосилку",
    tagString: "газонокосилка газон трава",
    tags: [
      {
        tag: "газонокосилка",
        tagLink: "#",
      },
      {
        tag: "газон",
        tagLink: "#",
      },
      {
        tag: "трава",
        tagLink: "#",
      },
    ],
    linkToArticle: "/country/Выбираем газонокосилку",
    text: [
      {
        attribute: "paragraph",
        content:
          "Рассмотрим основные характеристики, представленных на рынке типов газонокосилок. А также обратим внимание на ряд особенностей, влияющих на принятие окончательного решения, при выборе соответствующей вашим нуждам модели.",
      },
      {
        attribute: "paragraph",
        content: "Классификация газонокосилок:",
      },
      {
        attribute: "list",
        content: [
          { item: "механические" },
          { item: "электрические" },
          { item: "аккумуляторные" },
          { item: "бензиновые" },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "Механические газонокосилки бесшумны и экологичны, режущий механизм приводится в движение колесами тележки. Требуют определенных физических усилий и частой заточки ножей.",
      },
      {
        attribute: "paragraph",
        content:
          "Электрические модели популярны благодаря низкой цене, легкости и небольшим габаритам. К недостаткам относятся невысокая производительность, ограниченность обрабатываемой поверхности длиной кабеля.",
      },
      {
        attribute: "image",
        content: vybiraemgaz1,
      },
      {
        attribute: "paragraph",
        content:
          "Аккумуляторные газонокосилки подойдут для участков со сложным рельефом и большим количеством препятствий. Они сочетают в себе мобильность бензиновых газонокосилок и легкость и маневренность электрических.",
      },
      {
        attribute: "image",
        content: vybiraemgaz2,
      },
      {
        attribute: "paragraph",
        content:
          "Бензиновые модели бывают ручными и самоходными. К ручным относятся триммеры(бензокосы), самоходные модели движутся сами, а газонокосильщик либо идет за ней, либо управляет, сидя на газонокосилке. Данный тип косилок способен обрабатывать большие территории.",
      },
      {
        attribute: "paragraph",
        content: "На что еще следует обратить внимание при выборе:",
      },
      {
        attribute: "list",
        content: [
          { item: "наличие травосборника" },
          { item: "возможность регулировки высоты кошения" },
          { item: "наличие «детской» кнопки" },
        ],
      },
      {
        attribute: "paragraph",
        content:
          "На окончательное решение влияют: площадь и рельеф участка, а также разновидность скашиваемой растительности. Для небольших газонов подойдут механические колесные, а самоходные газонокосилки — для больших землевладений. Триммеры будут незаменимы на сложных, ограниченных участках, между деревьями и кустарниками.",
      },
    ],
  },
  // ARTICLE 3 END

  // ARTICLE 4 START
  {
    id: "Виды банных веников",
    img: vidyVenikov1,
    pretitle: "Дача",
    title: "Виды банных веников",
    tagString: "баня банный веник",
    tags: [
      {
        tag: "баня",
        tagLink: "#",
      },
      {
        tag: "банный",
        tagLink: "#",
      },
      {
        tag: "веник",
        tagLink: "#",
      },
    ],
    linkToArticle: "/country/Виды банных веников",
    text: [
      {
        attribute: "paragraph",
        content:
          "Какой поход в русскую баню обходится без веника? Но далеко не все знают, что правильно подобранный веник может значительно увеличить целебные и расслабляющие свойства банных процедур. Существует большое количество веников, обладающих самыми разнообразными качествами. Далее подробнее о самых популярных и распространенных видах.",
      },
      {
        attribute: "title",
        content: "Березовые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Веники, сделанные из молодых ветвей березы, являются самыми распространенными. Они оказывают благоприятное воздействие на дыхательные пути, снижают боль в суставах и мышцах, способствуют омоложению кожи. Заготавливают в конце весны-начале лета, такие веники обладают всеми полезными свойствами и долго хранятся.",
      },
      {
        attribute: "image",
        content: vidyVenikov2,
      },
      {
        attribute: "title",
        content: "Дубовые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Так же, как и березовые, дубовые веники обладают лечебными и омолаживающими свойствами. Хорошо известно, что дубовые веники помогают в лечении гипертонических заболеваний. Веник из дуба более массивный и плотный, чем остальные виды. Заготовку осуществляют в августе-сентябре.",
      },
      {
        attribute: "title",
        content: "Хвойные веники",
      },
      {
        attribute: "paragraph",
        content:
          "Материалом для заготовки хвойных веников служат можжевельник, пихта, кедр и ель. Такие веники обладают противовоспалительными качествами, помогают в борьбе со стрессом, головными болями, туберкулезом, радикулитом, кожными заболеваниями. Особенно полезным считается можжевеловый веник, который помимо указанных, помогает еще и в профилактике заболеваний печени и кишечника. Обращаться с такими вениками следует осторожно, чтобы не травмировать кожный покров. Для распаривания подобных веников требуется довольно много времени. Так как хвойные породы вечно зеленые, заготавливать их можно в течение всего года.",
      },
      {
        attribute: "image",
        content: vidyVenikov3,
      },
      {
        attribute: "title",
        content: "Липовые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Мало кто знает, но раньше липовые веники были более популярными, чем все другие. Сейчас их используют реже, еще и по той причине, что многие просто не знают о полезных свойствах этого удивительного дерева. Использование липовых веников укрепляет организм, а именно лечит простудные заболевания, кожные болезни, снимает стрессовые расстройства. Заготавливаются в период цветения липы.",
      },
      {
        attribute: "title",
        content: "Крапивные веники",
      },
      {
        attribute: "paragraph",
        content:
          "Такие веники помогают при заболеваниях печени и почек, ревматизме, подагре, радикулите. Стоит заметить, что запаривание снижает целебные свойства, поэтому следует лишь не надолго опустить его в горячую воду, после чего сразу же париться. Сбор крапивных веников производится с мая по июль.",
      },
      {
        attribute: "image",
        content: vidyVenikov4,
      },
      {
        attribute: "title",
        content: "Черемуховые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Черемуховые веники при запаривании приобретают ярко выраженный аромат цветущей черемухи. Они обладают противовоспалительными качествами, а вода в которой запаривался веник отлично укрепляет корни волос.",
      },
      {
        attribute: "title",
        content: "Эвкалиптовые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Очень редкий и очень полезный веник для бани. Помогает при радикулите, ревматизме, невралгии, кожных заболеваниях, снимает боль  при ушибах. Лечит заболевания дыхательных путей.",
      },
      {
        attribute: "title",
        content: "Рябиновые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Рябиновые веники отлично тонизируют и поднимают настроение. Полезны при атеросклерозе и повышенном давлении. Помимо этого они обеззараживают воздух в бане.",
      },
      {
        attribute: "title",
        content: "Ясеневые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Несмотря на то, что ясень считается ядовитым растением, при умеренном использовании обладает уникальными свойствами. Такие веники рекомендуются при артритах, ревматизме, подагре, заболеваниях дыхательных путей, а также как кровоостанавливающее, противовоспалительное и ранозаживляющее средство.",
      },
      {
        attribute: "title",
        content: "Кленовые веники",
      },
      {
        attribute: "paragraph",
        content:
          "По целебным свойствам очень похожи на березу. Помимо этого являются хорошим обезболивающим и противовоспалительным средством.",
      },
      {
        attribute: "title",
        content: "Ольховые веники",
      },
      {
        attribute: "paragraph",
        content:
          "Также очень схожи по полезности для организма с березой, кроме этого помогают в профилактике сердечно-сосудистых заболеваний и заболеваний суставов. Один веник может быть использован в нескольких банных процедурах.",
      },
      {
        attribute: "title",
        content: "Веники из орешника",
      },
      {
        attribute: "paragraph",
        content:
          "Такие веники необходимо заготавливать весной, пока ветви орешника молодые. Вещества, содержащиеся в листьях и ветках, будут полезны для больных диабетом, кожными заболеваниями, с нарушенным обменом веществ.",
      },
      {
        attribute: "title",
        content: "Полынные веники",
      },
      {
        attribute: "paragraph",
        content:
          "Полынные веники успокаивают, снимают напряжение и усталость, улучшают сон, память и работоспособность. Сбор следует производить после окончания цветения растения.",
      },
      {
        attribute: "image",
        content: vidyVenikov5,
      },
      {
        attribute: "paragraph",
        content:
          "Существуют и смешанные веники, когда к ветвям добавляют различные лекарственные и ароматные травы.",
      },
    ],
  },
  // ARTICLE 4 END
];
